module.exports = __webpack_public_path__ + "img/office1.6bb0b5d0.jpg";